module.exports = __webpack_public_path__ + "static/media/git-alt.02d0d6c2.svg";